import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveParametro } from './../../shared/components';

export type CreateParametroPageProps = {};

const CreateParametroPage: React.FC<CreateParametroPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_parametro);

  return <SaveParametro title="Crear Parámetro del Sistema" />;
};

export default CreateParametroPage;
